import { useSuspenseQuery } from '@apollo/client';

import { GenericError } from '@xing-com/crate-career-hub-common';
import { CareerHubTopicsDocument } from '@xing-com/crate-career-hub-topics';
import { ErrorBoundary } from '@xing-com/crate-core-error-boundary';
import { NoSSRLoggedInSuspense } from '@xing-com/crate-utils-no-ssr';

import { Topic } from './topic';
import { Styled } from './topic-list.styles';
import { TopicSkeleton } from './topic-skeleton';

export const TopicListInner: React.FC = () => {
  const { data } = useSuspenseQuery(CareerHubTopicsDocument);

  return data?.careerHubTopics?.collection?.map((topic) => {
    if (!topic) return null;
    const { title, key, description, articles } = topic;
    return (
      <Topic
        key={key}
        slug={key}
        title={title}
        description={description ?? ''}
        articles={articles}
      />
    );
  });
};

export const TopicList: React.FC = () => {
  return (
    <Styled.Wrapper>
      <ErrorBoundary
        onError={() => (
          <GenericError refetch={() => window.location.reload()} />
        )}
      >
        <NoSSRLoggedInSuspense fallback={<TopicSkeleton />}>
          <TopicListInner />
        </NoSSRLoggedInSuspense>
      </ErrorBoundary>
    </Styled.Wrapper>
  );
};
